import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue';
import clerk from '@/lib/clerk';
import { defineMessages } from '@/lib/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SamlCallbackPage',
  setup(__props) {

const m = defineMessages({
  description: '処理中です...',
});

onMounted(async () => {
  // handleRedirectCallback will automatically redirect to the URLs specified here
  // after successfully processing the SAML callback
  await clerk.handleRedirectCallback({
    signInFallbackRedirectUrl: '/#/saml/complete',
    signUpFallbackRedirectUrl: '/#/saml/complete',
    firstFactorUrl: '/#/saml/error',
    secondFactorUrl: '/#/saml/error',
  });
});

return { __sfc: true,m }
}

})